import parse from 'html-react-parser';
import { Component } from 'react';
import QuickReplyList from '../../containers/QuickReplyList';
import { sendNavigateToUrl } from '../../services/postMessageService';
import type { Button, MessageWithButtonsData } from '../../types/ChatWindow';
import type { MessageScheme } from '../../types/configs';
import { purifyAndLinkifyText } from './messageHelper';

class ButtonedTextMessage extends Component<
  {
    data: MessageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  },
  { buttonClicked: boolean }
> {
  constructor(props: {
    data: MessageWithButtonsData;
    scheme: MessageScheme;
    submitHandler: (...args: any[]) => void;
  }) {
    super(props);
    this.state = {
      buttonClicked: false,
    };
  }

  handleClick = (clickedButton: Button) => {
    const {
      submitHandler,
      data: { llmUsageId },
    } = this.props;
    const submitData = {
      value: clickedButton,
    };

    if (clickedButton.url) {
      sendNavigateToUrl(
        clickedButton.url,
        clickedButton?.options?.webclient?.urlOpenMethod,
      );

      Object.assign(submitData, {
        value: {
          ...submitData.value,
          llmUsageId,
        },
        postbackType: 'buttonClick',
      });

      return submitHandler({ ...submitData, shouldHideMessage: true });
    }

    // If the button is not a URL button, for example it is a Menu button, then we will show the button as clicked.
    // Convert the clicked button to a text and do not show the button anymore.
    this.setState({
      buttonClicked: true,
    });
    return submitHandler({ ...submitData });
  };

  render() {
    const { buttonClicked } = this.state;
    const {
      data: { text, buttons },
      scheme: { messageBubbleColor, messageBubbleTextColor },
      scheme,
    } = this.props;

    const message = purifyAndLinkifyText(text);
    const showText = typeof text === 'string' && text !== '';

    return (
      <>
        {showText && (
          <div
            className='word-break-style message-content'
            style={{
              backgroundColor: messageBubbleColor,
              color: messageBubbleTextColor,
            }}>
            {parse(message)}
          </div>
        )}
        {!buttonClicked && buttons?.length > 0 && (
          <QuickReplyList
            buttons={buttons}
            onClick={this.handleClick}
            scheme={scheme}
          />
        )}
      </>
    );
  }
}

export default ButtonedTextMessage;
